'use client';

import { useQuery } from '@tanstack/react-query';

export interface BotWithStats {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  status: 'draft' | 'published' | 'suspended';
  primaryLanguage: string;
  deactivatedAt: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  questionCount: number;
  qualityScore: number | null;
  leadCount: number;
}

interface BotsResponse {
  data: BotWithStats[];
  meta: { total: number };
}

export interface UseBotsParams {
  sort?: string;
  order?: string;
  search?: string;
}

async function fetchBots(params: UseBotsParams): Promise<BotsResponse> {
  const searchParams = new URLSearchParams();
  if (params.sort) searchParams.set('sort', params.sort);
  if (params.order) searchParams.set('order', params.order);
  if (params.search) searchParams.set('search', params.search);

  const url = `/api/bots${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  const res = await fetch(url);

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error?.error?.message || 'Failed to fetch bots');
  }

  return res.json();
}

export function useBots(params: UseBotsParams = {}) {
  return useQuery({
    queryKey: ['bots', params],
    queryFn: () => fetchBots(params),
    staleTime: 30 * 1000, // 30 seconds
  });
}
